'use es6';

import { useTheme } from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Field from '../component/Field';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Box } from 'foundations-components/transitional/components/Box';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.genericInboxForm';
const SecuritySettings = ({
  fieldProps,
  handleFieldChange,
  isExpanded,
  validationMessages,
  value
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      typography: "heading-100",
      marginBlockStart: "1000",
      marginBlockEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${LANG_ROUTE}.security.heading`
      })
    }), value.acceptUntrustedCert && /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "InboxConnectUtils.genericInboxForm.security.tooltip"
      })
    }), /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
      "aria-hidden": !isExpanded,
      error: Boolean(validationMessages.acceptUntrustedCert),
      checked: value.acceptUntrustedCert,
      color: validationMessages.acceptUntrustedCert && !value.acceptUntrustedCert ? theme.color['text-alert-default'] : undefined,
      Component: Checkbox,
      messageKeySuffix: "",
      name: "acceptUntrustedCert",
      onChange: ({
        target: {
          checked
        }
      }, fieldName) => handleFieldChange({
        target: {
          value: checked
        }
      }, fieldName),
      validationMessage: !!validationMessages.acceptUntrustedCert && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: validationMessages.acceptUntrustedCert
      }),
      value: "",
      children: /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${LANG_ROUTE}.security.acceptUntrustedCertLabel`,
          marginInlineEnd: "200"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "InboxConnectUtils.genericInboxForm.security.tooltip"
          })
        })]
      })
    }))]
  });
};
SecuritySettings.propTypes = {
  fieldProps: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  validationMessages: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};
export default SecuritySettings;